var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArithmeticOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.07 37.5004C31.07 36.5339 31.8535 35.7504 32.82 35.7504H49.1533C50.1198 35.7504 50.9033 36.5339 50.9033 37.5004C50.9033 38.4669 50.1198 39.2504 49.1533 39.2504H32.82C31.8535 39.2504 31.07 38.4669 31.07 37.5004Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.07 46.8338C31.07 45.8673 31.8535 45.0838 32.82 45.0838H49.1533C50.1198 45.0838 50.9033 45.8673 50.9033 46.8338C50.9033 47.8003 50.1198 48.5838 49.1533 48.5838H32.82C31.8535 48.5838 31.07 47.8003 31.07 46.8338Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1566 33.7468C23.84 34.4302 23.8401 35.5383 23.1566 36.2217L9.95733 49.421C9.27391 50.1044 8.16587 50.1044 7.48245 49.421C6.79904 48.7376 6.79903 47.6296 7.48245 46.9461L20.6818 33.7468C21.3652 33.0634 22.4732 33.0634 23.1566 33.7468Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48245 33.7468C8.16587 33.0634 9.27391 33.0634 9.95733 33.7468L23.1566 46.9461C23.84 47.6296 23.84 48.7376 23.1566 49.421C22.4732 50.1044 21.3651 50.1044 20.6817 49.421L7.48245 36.2217C6.79903 35.5383 6.79904 34.4302 7.48245 33.7468Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.07 15.3338C31.07 14.3673 31.8535 13.5838 32.82 13.5838H49.1533C50.1198 13.5838 50.9033 14.3673 50.9033 15.3338C50.9033 16.3003 50.1198 17.0838 49.1533 17.0838H32.82C31.8535 17.0838 31.07 16.3003 31.07 15.3338Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40332 15.3338C5.40332 14.3673 6.18682 13.5838 7.15332 13.5838H23.4867C24.4532 13.5838 25.2367 14.3673 25.2367 15.3338C25.2367 16.3003 24.4532 17.0838 23.4867 17.0838H7.15332C6.18682 17.0838 5.40332 16.3003 5.40332 15.3338Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.32 5.41711C16.2865 5.41711 17.07 6.20062 17.07 7.16711V23.5004C17.07 24.4669 16.2865 25.2504 15.32 25.2504C14.3535 25.2504 13.57 24.4669 13.57 23.5004V7.16711C13.57 6.20062 14.3535 5.41711 15.32 5.41711Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArithmeticOne);
export default __webpack_public_path__ + "static/media/arithmetic-one.af0b46ac.svg";
export { ForwardRef as ReactComponent };